import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/website-build/website-build/src/Layout.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Title = makeShortcode("Title");
const Section = makeShortcode("Section");
const Image = makeShortcode("Image");
const SubTitle = makeShortcode("SubTitle");
const Link = makeShortcode("Link");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Title mdxType="Title">Urban Hydro Climate</Title>
    <Section mdxType="Section">
  <Image src={'https://sjyurbanlab.github.io/website-assets/research-theme/urban-hydro-climate/urban-hydro-climate.jpg'} alt={'urban hydro climate'} size={'medium'} center mdxType="Image" />
    </Section>
    <Section mdxType="Section">
      <SubTitle mdxType="SubTitle">Reference</SubTitle>
      <p><strong parentName="p">{`Song J`}</strong>{`, Wang Z-H, Wang C (2018). `}<Link href={'https://doi.org/10.1029/2018JD028302'} mdxType="Link">{`The regional impact of urban heat mitigation strategies on planetary boundary-layer dynamics over a semiarid city. `}<em parentName="p">{`Journal of Geophysical Research: Atmosphere`}</em>{`, 123(3), 6410-6422.`}</Link></p>
      <p><strong parentName="p">{`Song J`}</strong>{`, Wang Z-H, Myint SW, Wang C (2017). `}<Link href={'https://doi.org/10.1016/j.landurbplan.2017.06.024'} mdxType="Link">{`The hysteresis effect on surface-air temperature relationship and its implications to urban planning: An examination in Phoenix, Arizona, USA. `}<em parentName="p">{`Landscape and Urban Planning`}</em>{`, 167, 198-211.`}</Link></p>
      <p><strong parentName="p">{`Song J`}</strong>{`, Xia J, Zhang L, Wang Z-H, Wan H, She D (2016). `}<Link href={'https://doi.org/10.2166/nh.2015.155'} mdxType="Link">{`Streamflow prediction in ungauged basins by regressive regionalization: a case study in Huai River Basin, China. `}<em parentName="p">{`Hydrology Research`}</em>{`, 47(5), 1053-1068.`}</Link></p>
    </Section>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      